import Modal from '@sharedComponents/Modal';
import { createContext, useContext, useMemo, useRef, useState } from 'react';

const defaultState = { component: null, props: {} };

export const ModalContext = createContext({
    component: null,
    actions: {
        open() {},
        close() {},
    },
});

export const useModal = () => useContext(ModalContext);

const ModalManager = () => {
    const { isOpened, component: Component, props, openKey, actions } = useModal();

    return (
        <>
            <Modal {...props} isOpened={isOpened} onClose={props.onClose ? props.onClose : actions.close} isClosable={props.isClosable}>
                {Component && <Component {...props} key={openKey} />}
            </Modal>
        </>
    );
};

export const ModalProvider = ({ children }) => {
    const [openState, setOpenState] = useState(false);
    const [state, setState] = useState(defaultState);
    const openKeyRef = useRef(0);
    const [openKey, setOpenKey] = useState(0);

    const actions = useMemo(
        () => ({
            open({ component = null, isClosable = true, ...props }) {
                openKeyRef.current += 1;
                setState({
                    component,
                    isClosable,
                    props: {
                        ...props,
                        isClosable,
                    },
                });
                setOpenKey(openKeyRef.current);
                setOpenState(true);
            },
            close() {
                setOpenState(false);
            },
        }),
        [],
    );

    return (
        <ModalContext.Provider
            value={{
                isOpened: openState,
                component: state.component,
                isClosable: state.isClosable,
                props: state.props,
                openKey,
                actions,
            }}
        >
            <ModalManager />
            {children}
        </ModalContext.Provider>
    );
};
